'use client'

import styled from "styled-components";
import {Select} from "antd";
import {getColor} from "@/pipes/theme.pipe";
import {getVariantStyles} from "@/components/UI/Form/Selects/Select/options/variant.options";
import {getSizeOptions} from "@/components/UI/Form/Selects/Select/options/size.options";

export const SelectWrapper = styled.div`
    width: 100%;
`

export const SelectStyled = styled(Select)`
    border-radius: 20px;
    background: ${getColor('secondary', '600')};
    width: 100%;
    height: 100%;
    position: relative;
    
    .ant-select-selector {
        border-radius: 20px;
        min-height: 40px !important;
        height: fit-content !important;
        padding-left: 25px !important;
        border: none !important;
        
        &:hover, &:active, &:focus, &:focus-within, &:focus-visible {
            border: 1px solid ${getColor('secondary', '300')} !important;
        }
    
        span {
            text-align: left;
            svg {
                padding-right: ${({ mode }) => mode !== 'multiple' ? '30px' : 0} !important;
            }
        }
        
        input {
            box-shadow: none;
        }
        
        .ant-select-selection-overflow {
            .ant-select-selection-item {
                background: ${getColor('natural', '900')};
                height: auto !important;
                text-wrap: wrap;
            }
        }
        
        .ant-select-selection-item-content {
            text-wrap: wrap;
        }
    }

    .ant-select-selection-item-remove {
        display: none !important;
    }
    
    ${getVariantStyles}
    ${getSizeOptions}
`

export const SelectDropdown = styled.div`
    padding: 0 !important;
    
    .ant-select-item {
        padding: 10px 22px !important;

        span {
            text-wrap: wrap;
        }
    }

    div > button {
        width: 100% !important;
    }
    
    ${getVariantStyles}
    ${getSizeOptions}
`

export const SelectOptionStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    
    & > span {
        width: 100%;
        //max-width: 15ch;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-block: 5px;
`